module.exports = __webpack_public_path__ + "static/media/journal-style-03.b7a7fe01.svg";